import React, { Component } from 'react'
import AddNewCo from './AddNewCo'
import { GetData } from '../../../api/service'
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core'
import Edit from '@material-ui/icons/Edit'

export default class CoLanding extends Component {
    state = {
        list: [],
        isLoaded: false
    }

    componentDidMount() {
        GetData(`/${this.props.apikey}/getcourse`)
            .then((resp) => {
                this.setState({
                    list: resp,
                    isLoaded: true
                })
            })
    }

    render() {
        return (
            <div>
                <Typography variant="h6">
                    Outcomes
            </Typography>

            <Button onClick={() => this.props.history.push('/courseoutcome/add')}>
                Add Course Outcome
            </Button>

                <Table size="small">

                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Dept Code</TableCell>
                            <TableCell>Program Outcome</TableCell>
                            <TableCell>Program Specific Outcome</TableCell>
                            <TableCell>Course Outcome</TableCell>
                            <TableCell>Edit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.list.map((el, index) =>
                            <TableRow key={index} style={{verticalAlign: 'top'}}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{el.dept_code}</TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.program_outcome }}></TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.program_specific_outcome }}></TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.course_outcome}}></TableCell>
                                
                                <TableCell><Edit onClick={() => this.props.history.push('/courseoutcome/edit', el)} /></TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                </Table>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Department/CO/CoLanding.js